import {ChangeDetectorRef, Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {CycleCountService} from "../../providers/cyclecount.service";
import {TranslateService} from "@ngx-translate/core";

/**
 * Generated class for the PopoverCyclecountProgressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover-cyclecount-progress',
  templateUrl: 'popover-cyclecount-progress.html',
})
export class PopoverCyclecountProgressPage {

  title = '';
  progress = '0';
  shouldUpdateView = true;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private cycleCountService: CycleCountService,
              public translate: TranslateService,
              private cdr: ChangeDetectorRef) {
    this.title = navParams.get('title');
    this.initRecursiveGetProgress();
  }

  ionViewWillLeave(){
    this.shouldUpdateView = false;
  }

  // TODO: CHANGE TO EVENTS
  initRecursiveGetProgress() {
    setTimeout(() => {
      if(this.shouldUpdateView){
        this.progress = String(Math.trunc(this.cycleCountService.uploadProgress < 100 ? this.cycleCountService.uploadProgress : 100));
        this.cdr.detectChanges();
        this.initRecursiveGetProgress();
      }
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./src/pages/popover-cyclecount-progress/popover-cyclecount-progress.ts